import React, { useState } from 'react';
import './VolumeComponents.css';
import {
  VolumeHighOutline,
  VolumeMediumOutline,
  VolumeLowOutline,
  VolumeMuteOutline,
  VolumeOffOutline,
} from 'react-ionicons';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentVolume } from '../../../store/features/playerSlice';

/**
 * creates the volume slider used in the playerBar
 * @example <VolumeSlider />
 * @returns {void}
 */
const VolumeSlider = () => {
  const [volume, setVolume] = useState(1);
  const [muted, setMuted] = useState(false);
  const dispatch = useDispatch();
  const currentVolume = useSelector((state) => state.player.playingVolume);

  /**
   * reflects the high volume icon
   * @returns {void}
   */
  const highVolume = () => (
    <VolumeHighOutline
      onClick={() => toggleMute()}
      style={{
        cursor: 'pointer',
        display: 'block',
        justifySelf: 'center',
        alignSelf: 'center',
      }}
      color={'#fff'}
      width="25px"
      height="25px"
    />
  );

  /**
   * reflects mid volume icon
   * @returns {void}
   */
  const midVolume = () => (
    <VolumeMediumOutline
      onClick={() => toggleMute()}
      style={{
        cursor: 'pointer',
        display: 'block',
        justifySelf: 'center',
        alignSelf: 'center',
      }}
      color={'#fff'}
      width="25px"
      height="25px"
    />
  );

  /**
   * reflects the low volume icon
   * @returns {void}
   */
  const lowVolume = () => (
    <VolumeLowOutline
      onClick={() => toggleMute()}
      style={{
        cursor: 'pointer',
        display: 'block',
        justifySelf: 'center',
        alignSelf: 'center',
      }}
      color={'#fff'}
      width="25px"
      height="25px"
    />
  );

  /**
   * reflects the  very high volume icon
   * @returns {void}
   */
  const veryLowVolume = () => (
    <VolumeOffOutline
      onClick={() => toggleMute()}
      style={{
        cursor: 'pointer',
        display: 'block',
        justifySelf: 'center',
        alignSelf: 'center',
      }}
      color={'#fff'}
      width="25px"
      height="25px"
    />
  );

  /**
   * reflects the mute  icon
   * @returns {void}
   */
  const muteVolume = () => (
    <VolumeMuteOutline
      onClick={() => toggleMute()}
      color={'#fff'}
      width="25px"
      height="25px"
    />
  );

  /**
   * when volume icon is clicked mutes the sound if clicked again retakes the sound.
   * @returns {void}
   */
  const toggleMute = () => {
    muted ? setMuted(false) : setMuted(true);
    muted
      ? dispatch(updateCurrentVolume(0))
      : dispatch(updateCurrentVolume(volume));
  };

  /**
   * mutates the local volume state and mutates the one located in store.
   * @param {InputEvent} event
   */
  const updateVolume = (event) => {
    setVolume(event.target.value);
    if (volume === 0.02) {
      dispatch(updateCurrentVolume(0.0));
    } else {
      dispatch(updateCurrentVolume(volume));
    }
  };

  return (
    <section style={{ display: 'flex', position: 'absolute', right: 20 }}>
      <div
        style={{
          width: '30px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginLeft: 'auto',
        }}>
        {currentVolume > 0.75
          ? highVolume()
          : currentVolume > 0.5
          ? midVolume()
          : currentVolume > 0.25
          ? lowVolume()
          : currentVolume < 25
          ? veryLowVolume()
          : currentVolume === 0
          ? muteVolume()
          : null}
      </div>
      <input
        onInput={(e) => updateVolume(e)}
        type="range"
        style={{ width: '85px' }}
        min={0}
        max={1}
        step={0.02}
        value={currentVolume}
        onChange={(e) => updateVolume(e)}
      />
    </section>
  );
};

export default VolumeSlider;
